import request from '@/utils/request'
import { v2Host } from '@/config/host'
import type { _Response } from '../type'
import {} from './type'
import { TrafficType } from '@pt/enums/insights'

// 检查推送名称是否重复
export function checkPushName(data: {
  name: string
  traffice_type?: TrafficType[]
}): _Response<{ is_available: boolean }> {
  return request({
    url: `${v2Host}/creative/push/check-name`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export interface revision {
  mws_creative_name: string
  version: number
  preview_url: string
  created_time: number
}

export interface previewHistoryInfo {
  project_name: string
  version: number
  preview_url: string
  revisions: revision[]
  actions: any
  languages: string
}

export function getPreviewHistoryInfo(data: {
  id: number
  from: number
}): _Response<previewHistoryInfo> {
  return request({
    url: `${v2Host}/creative/push/preview-revisions`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
